import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';

const useHook = (id: string) => {
  return useQuery(
    ['event_by_id', id],
    async () => {
      const response = await service.get(`/events/${id}`);
      return response.data;
    },
    {
      enabled: !!id,
    }
  );
};

export default useHook;
